// TYPES
import { ReducerAction } from 'store/modules/types';
import { IncluirEstatisticaRequest, Types } from './types';

export function incluirEstatisticaRequest(
	payload: IncluirEstatisticaRequest,
): ReducerAction {
	return {
		type: Types.INCLUIR_ESTATISTICA_REQUEST,
		payload,
	};
}
export function incluirEstatisticaSuccess(payload: string): ReducerAction {
	return {
		type: Types.INCLUIR_ESTATISTICA_SUCCESS,
		payload,
	};
}
export function incluirEstatisticaFailure(): ReducerAction {
	return {
		type: Types.INCLUIR_ESTATISTICA_FAILURE,
		payload: null,
	};
}
export function incluirEstatisticaClear(): ReducerAction {
	return {
		type: Types.INCLUIR_ESTATISTICA_CLEAR,
		payload: null,
	};
}
